import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Modal } from "react-responsive-modal";
import { PopupActionButton } from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { NewInputText } from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "../../../../../../function/InputNumberFunc";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import {
  super_admin_diner_status_change,
  super_admin_diner_status_change_test,
  get_all_vendor_seating_information,
} from "../../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import store from "../../../../../../store/store";
import { SET_VENDOR_INFORMATION } from "../../../../../../store/types";
import isEmpty from "../../../../../../store/validation/is-Empty";

export class SuperAdminEnterTableNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      enterTableNumber: "",
      diner_id: "",
      vendor_id: "",
      allData: {},
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.allDataProps) !== nextState.diner_id) {
      return {
        diner_id: nextProps.allDataProps._id,
        vendor_id: nextProps.allDataProps.vendor_id,
        allData: nextProps.allDataProps,
      };
    }
  }

  onOpenModal = (e) => {
    this.setState({ open: true });
  };

  onCloseModal = (e) => {
    this.setState({ open: false });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onCallBackFunc = (e) => {
    const data = { vendor_id: this.state.vendor_id };
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
    this.props.closedMainModal();
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  onSubmitHandler = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.diner_id;
    // const vendor_id = this.state.vendor_id;
    const formData = {
      table_number: this.state.enterTableNumber,
      diner_status: "SEATED",
      wait_time: parseInt(0),
      seatedTime: new Date().getTime(),
    };
    this.props.super_admin_diner_status_change_test(
      formData,
      diner_id,
      // vendor_id,
      token,
      this.onCallBackFunc
    );
  };

  render() {
    const { open, enterTableNumber } = this.state;
    return (
      <div>
        {this.props.displayButton === "mobile" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass={this.props.buttonClass}
            onClick={this.onOpenModal}
          />
        ) : (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="yesButton"
            onClick={this.onOpenModal}
          />
        )}
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="reusable-popup-header-newstyle">
            <h4 className="c-black font_24_b">Enter Table Number</h4>
          </div>
          <div className="enter-table-number">
            <Form noValidate onSubmit={this.onSubmitHandler}>
              <Row className="justify-content-center">
                <div className="col-9">
                  <NewInputText
                    extraClass="mt-5 mb-5"
                    name="enterTableNumber"
                    inputType="number"
                    onChange={this.onChange}
                    onKeyDown={InputNumberFunc}
                    maxLength="10"
                    onChange={this.onChange}
                    value={this.state.enterTableNumber}
                    labelText="Enter Table Number"
                    controlClass={"outlined-helperText "}
                  />
                </div>
              </Row>
              <div className="mt-4 d-flex">
                <PopupActionButton
                  buttonText="No"
                  buttonType="button"
                  buttonClass="noButton"
                  onClick={this.onCloseModal}
                />
                <div className="ml-3">
                  <PopupActionButton
                    buttonText="Confirm"
                    buttonType={enterTableNumber === "" ? "button" : "Submit"}
                    buttonClass="yesButton"
                  />
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

SuperAdminEnterTableNumber.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  super_admin_diner_status_change,
  super_admin_diner_status_change_test,
  get_all_vendor_seating_information,
})(withRouter(SuperAdminEnterTableNumber));
